/**
 *	(c) 2024 Приволжский Исследовательский Медицинский Университет
 *
 *	@file: App.js
 *  @description: Этот файл является частью клиентской стороны проекта. В этом файле находится обёртка приложения, запускаемая при обращении к любой странице клиентской части. Здесь проверяется авторизация.
 *	@author: Белов Михаил Александрович, Горбас Александр Петрович
*/
import React, {useContext, useEffect, useState} from 'react';
import {BrowserRouter} from "react-router-dom";
import AppRouter from "./components/AppRouter";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import {observer} from "mobx-react-lite";
import {Context} from "./index";
import {check} from "./http/User_API";
import {Spinner} from "react-bootstrap";
import Cookies from 'js-cookie';

import YandexMetrikaTracker from './components/YandexMetrikaTracker';

import "./fonts.css";

const App = observer(() => {
    const {user} = useContext(Context);
    const [loading, setLoading] = useState(true);

    const CheckValidation = (data) => {
        if (!data)
            return false;

        user.setUser(true);
        user.setIsAuth(true);
        user.setProfile(data.user);
        user.setAccess_level(data.user.access_level);
        user.setCounters({});

        return true;
    };

    useEffect(() => {
        check().then(CheckValidation).finally(() => setLoading(false));
    }, []);

    if (loading)
    {
        return <div>
            <p>Загрузка...</p>
            <Spinner animation={"grow"}/>
        </div>;
    }

    return <BrowserRouter forceRefresh>
            <YandexMetrikaTracker />
            <NavBar/>
            <AppRouter />
            <Footer/>
    </BrowserRouter>;
});

export default App;